import {
  Maybe,
  LeaderboardLeaderBoardUserAccessChoices,
  LeaderboardChallengeStatusChoices,
  LeaderboardLeaderBoardTypeChoices,
} from '../../../__generated__/globalTypes'

import { LeaderFragment, isLeaderFragment } from './LeaderFragment'

import leaderBoardFragmentRawString from '../LeaderBoardFragment.graphql'

export const leaderBoardFragmentString = leaderBoardFragmentRawString

export type LeaderBoardFragment = {
  title: string
  description: string
  rankTitle: string
  metricTitle: string
  listTitle: string
  shouldShowPastChallenge: boolean
  gradient: Maybe<string>
  userAccess: LeaderboardLeaderBoardUserAccessChoices
  challenges: {
    id: string
    status: LeaderboardChallengeStatusChoices
    startDate: string
    endDate: string
    leaders: LeaderFragment[]
    authUserEarnedCount: number
  }[]
  type: LeaderboardLeaderBoardTypeChoices
}

export const isLeaderBoardFragment = (
  fragment: any,
): fragment is LeaderBoardFragment =>
  fragment &&
  typeof fragment.title === 'string' &&
  typeof fragment.description === 'string' &&
  typeof fragment.rankTitle === 'string' &&
  typeof fragment.metricTitle === 'string' &&
  typeof fragment.listTitle === 'string' &&
  typeof fragment.shouldShowPastChallenge === 'boolean' &&
  (fragment.gradient === null || typeof fragment.gradient === 'string') &&
  (fragment.userAccess === 'SP123' ||
    fragment.userAccess === 'S' ||
    fragment.userAccess === 'C' ||
    fragment.userAccess === 'RC' ||
    fragment.userAccess === 'D' ||
    fragment.userAccess === 'GSA' ||
    fragment.userAccess === 'FGSA' ||
    fragment.userAccess === 'SA' ||
    fragment.userAccess === 'BBC' ||
    fragment.userAccess === 'BBD' ||
    fragment.userAccess === 'MBC' ||
    fragment.userAccess === 'MBD' ||
    fragment.userAccess === 'PBC' ||
    fragment.userAccess === 'PBD' ||
    fragment.userAccess === 'JO' ||
    fragment.userAccess === 'ID' ||
    fragment.userAccess === 'MD' ||
    fragment.userAccess === 'WCS' ||
    fragment.userAccess === 'ALL' ||
    fragment.userAccess === 'STAFF' ||
    fragment.userAccess === 'RETAIL' ||
    fragment.userAccess === 'REP') &&
  Array.isArray(fragment.challenges) &&
  fragment.challenges
    .slice(0, 5)
    .reduce(
      (accum: any, next: any) =>
        accum &&
        next &&
        typeof next.id === 'string' &&
        (next.status === 'ACTIVE' ||
          next.status === 'SCHEDULED' ||
          next.status === 'COMPLETED') &&
        typeof next.startDate === 'string' &&
        typeof next.endDate === 'string' &&
        Array.isArray(next.leaders) &&
        next.leaders
          .slice(0, 5)
          .reduce(
            (accum: any, next: any) =>
              accum && (isLeaderFragment(next) as boolean),
            true,
          ) &&
        typeof next.authUserEarnedCount === 'number',
      true,
    ) &&
  (fragment.type === 'DIST' ||
    fragment.type === 'FIRST' ||
    fragment.type === 'TRANS')
